<script>
import { Doughnut, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins

export default {
  extends: Doughnut,
  mixins: [ reactiveProp ],
  props: [ 'chartData', 'options' ],
  mounted() {
    this.renderChart(this.chartData, {
      responsive: false,
      responsiveAnimationDuration: 0,
      animation: {
          duration: 0
      },
      devicePixelRatio: 2,
      animation: false,
      ...this.options,
    })
  }
}

</script>

<style>

</style>
